import { Alert, AlertDescription, AlertTitle } from './ui/alert';
import {
  CheckCircleIcon,
  SealWarningIcon,
  WarningIcon,
  InfoIcon,
} from '@phosphor-icons/react';

interface BannerProps {
  title?: string;
  description: string;
  variant: 'success' | 'error' | 'warning' | 'info';
}

export function Banner({ title, description, variant }: BannerProps) {
  const renderIcon = () => {
    switch (variant) {
      case 'success':
        return <CheckCircleIcon size={20} weight="fill" />;
      case 'error':
        return <SealWarningIcon size={20} weight="fill" />;
      case 'warning':
        return <WarningIcon size={20} weight="fill" />;
      case 'info':
        return <InfoIcon size={20} weight="fill" />;
    }
  };

  const _title = title || `${variant} banner`;
  const _description = description || `This is a ${variant} banner.`;

  return (
    <Alert variant={variant}>
      {renderIcon()}
      <AlertTitle className={title ? '' : 'sr-only'}>{_title}</AlertTitle>
      <AlertDescription className={description ? '' : 'sr-only'}>
        {_description}
      </AlertDescription>
    </Alert>
  );
}

